import React from 'react';
import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))<Pick<React.CSSProperties, 'maxWidth' | 'minWidth' | 'fontSize'>>(
  ({ maxWidth = '75%', minWidth = '300px', fontSize = '0.85rem' }) => ({
    [`&.${tooltipClasses.popper}`]: {
      maxWidth,
      minWidth,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 'stretch',
      fontSize,
    },
  })
);
